import { createBrowserRouter, type RouteObject } from 'react-router';
import { appRoutes } from './routes';

// Dev-only living reference. `import.meta.env.DEV` is a build-time constant, so the production
// bundle contains neither this route nor the page (asserted by `design-not-shipped.test.ts`).
const designRoutes: RouteObject[] = import.meta.env.DEV
  ? [
      {
        path: '/design',
        hydrateFallbackElement: <></>,
        lazy: async () => ({ Component: (await import('../pages/design')).DesignPage }),
      },
    ]
  : [];

export const router = createBrowserRouter(appRoutes({ signedInExtras: designRoutes }));
